<template>
  <div class="role-page">
    <layout>
      <template v-slot:content>
        <a-space class="table-operator">
          <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加</a-button>
          <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo('destroy')">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="destroy()"><a-icon type="delete" />删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /></a-button>
          </a-dropdown>
        </a-space>

        <a-table
          :columns="columns"
          :row-key="record => record.id"
          :data-source="data"
          :row-selection="{ onChange: onSelectChange }"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
        >
          <div slot="status" slot-scope="enabled">
            <a-tag :color="enabled ? 'green' : 'red'">
              {{ enabled ? '正常' : '禁用' }}
            </a-tag>
          </div>
          <div slot="show_display_worker" slot-scope="show_display_worker">
            <a-tag :color="show_display_worker ? 'green' : 'red'">
              {{ show_display_worker ? '展示' : '不展示' }}
            </a-tag>
          </div>
          <div slot="action" slot-scope="record" class="actions">
            <template v-if="accessTo(['update', 'destroy'])">
              <a href="javascript:;" @click="create(record)" v-if="accessTo('store')">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认要删除吗?" @confirm="destroy(record)" v-if="accessTo('destroy')">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template v-else>-</template>
          </div>
        </a-table>
      </template>
    </layout>
    <create-form
      :showForm.sync="showForm"
      :model="model"
      @success="refresh"
      ref="createForm"
    />
  </div>
</template>

<style lang="less" scoped>
@import 'Role';
</style>

<script>
import Role from './Role'
export default Role
</script>
